import React from 'react'
import { useTranslation } from 'react-i18next'

import {
  ToggleRadioButtonGroup,
  type ToggleRadioButtonGroupProps,
} from '~/components/elements/ToggleRadioButtonGroup'

type TabKey = 'brand' | 'column' | 'row'

export type TabSwitcherProps = {
  disabled?: boolean
  onChange?: (value: TabKey) => void
  showBrand?: boolean
  value: TabKey
}

export const TabSwitcher = ({
  disabled,
  onChange,
  showBrand = false,
  value,
}: TabSwitcherProps) => {
  const { t } = useTranslation()

  const attributes = React.useMemo<
    ToggleRadioButtonGroupProps<TabKey>['attributes']
  >(() => {
    const items: ToggleRadioButtonGroupProps<TabKey>['attributes'] = [
      { text: t('row'), value: 'row' },
      { text: t('column'), value: 'column' },
    ]

    if (showBrand) {
      items.push({ text: t('brand_tab'), value: 'brand' })
    }

    return items
  }, [showBrand, t])

  return (
    <ToggleRadioButtonGroup
      attributes={attributes}
      disabled={disabled}
      value={value}
      onChange={onChange}
    />
  )
}
